<ispui-input
  forceplaceholder="true"
  [invalid]="showError"
  [style.width]="props.width$ | async"
>
  <input
    class="input"
    [id]="id"
    [placeholder]="props.placeholder$ | async"
    [formControl]="formControl"
    [formlyAttributes]="field"
    #inputRef
  />
</ispui-input>
